const ITEMS = ["Skip the line", "Zero wait", "Pre-order", "Express counter", "Grab & go", "No platform fee"];

export const Ticker = () => (
    <div className="overflow-hidden border-y-2 border-[#111111] bg-primary py-3" data-testid="ticker-strip">
        <div className="flex w-max animate-marquee gap-10">
            {[...ITEMS, ...ITEMS, ...ITEMS, ...ITEMS].map((item, i) => (
                <span key={i} className="flex items-center gap-10 text-sm font-extrabold uppercase tracking-[0.2em] text-[#111111]">
                    {item}
                    <span aria-hidden="true">✦</span>
                </span>
            ))}
        </div>
    </div>
);
